var exports = {
  "KC": "AuthorizedAppsTab.module__appList___NjBtYV",
  "Um": "AuthorizedAppsTab.module__appCard___NjBtYV",
  "sK": "AuthorizedAppsTab.module__appCardSelectable___NjBtYV",
  "nD": "AuthorizedAppsTab.module__appMain___NjBtYV",
  "tR": "AuthorizedAppsTab.module__appActions___NjBtYV",
  "FG": "AuthorizedAppsTab.module__appAvatar___NjBtYV",
  "O5": "AuthorizedAppsTab.module__appAvatarImage___NjBtYV",
  "Q2": "AuthorizedAppsTab.module__appAvatarPlaceholder___NjBtYV",
  "fI": "AuthorizedAppsTab.module__textBlock___NjBtYV",
  "JB": "AuthorizedAppsTab.module__appName___NjBtYV",
  "v8": "AuthorizedAppsTab.module__metaText___NjBtYV",
  "gb": "AuthorizedAppsTab.module__iconButton___NjBtYV",
  "R5": "AuthorizedAppsTab.module__revokeButton___NjBtYV",
  "gE": "AuthorizedAppsTab.module__actionIcon___NjBtYV",
  "Qn": "AuthorizedAppsTab.module__selectionHint___NjBtYV",
  "Jb": "AuthorizedAppsTab.module__scopeList___NjBtYV",
  "DL": "AuthorizedAppsTab.module__scopeTag___NjBtYV",
  "OK": "AuthorizedAppsTab.module__scopeName___NjBtYV",
  "RJ": "AuthorizedAppsTab.module__scopeDescription___NjBtYV",
  "g4": "AuthorizedAppsTab.module__loadingContainer___NjBtYV",
};

module.exports = exports;
